<script lang="ts" setup>
const emit = defineEmits(['update:model-value'])
defineProps({
  isGiftNeed: {
    type: Boolean,
    required: true,
  },
})

const updateValue = (value: boolean | null) =>
  emit('update:model-value', !!value)
</script>

<template>
  <div class="gifts-toggle">
    <div class="gifts-toggle__headline">Нужен подарок</div>

    <div class="gifts-toggle__control">
      <v-switch
        :model-value="isGiftNeed"
        :ripple="false"
        inset
        hide-details
        @update:model-value="updateValue"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.gifts-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;

  &__headline {
    font-size: 18px;
    font-weight: 800;
    color: $text-black;

    @include media('<tablet') {
      font-size: 14px;
    }
  }
}

/* v-switch custom */
:deep(.v-selection-control) {
  height: 32px;
  min-height: unset;
}

:deep(.v-switch__track) {
  width: 56px;
  height: 32px;
  margin: 0;
  background-color: $very-light-grey;
  opacity: 1;
}

:deep(.v-selection-control__input) {
  width: 26px;
  height: 26px;
  background-color: white;
  box-shadow: 0 2px 5px -3px black;

  &:before {
    content: none;
  }
}

:deep(.v-selection-control--dirty .v-switch__track) {
  background-color: $primary !important;
}

:deep(.v-selection-control--dirty .v-selection-control__input) {
  box-shadow: none;
}
</style>
